import createApp from 'createApp'
const landingInternalNav = () => import('Components/Landing/landingInternalNav.vue')
const aboutBox = () => import('Components/Landing/About/aboutBox.vue')

createApp({
  components: {
    landingInternalNav,
    aboutBox,
  },
})